// extracted by mini-css-extract-plugin
export default {"Container":"ScreenModalContent_Container__xuf7f","Image":"ScreenModalContent_Image__x6hQ9"};